import { isHomePage } from "../../utils/isHomePage";

const initCategoryImageLoading = () => {
  if (!isHomePage()) return;

  const categoryItems = document.querySelectorAll(".category-item");

  categoryItems.forEach((item) => {
    item.classList.add("loading");
    const img = item.querySelector("img");

    if (img) {
      if (img.complete) {
        item.classList.remove("loading");
      } else {
        img.addEventListener("load", () => {
          item.classList.remove("loading");
        });

        img.addEventListener("error", () => {
          item.classList.remove("loading");
          item.style.backgroundColor = "#eceaed"; // fallback to bg-light-gray
        });
      }
    }
  });
};

document.addEventListener("DOMContentLoaded", initCategoryImageLoading);
document.addEventListener("bottomContentLoaded", initCategoryImageLoading);
